

import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import axiosInstance from "../../../../Services/axiosCommon";
import NuDate from "../../../../Components/Utils/NuDate";
import { useToast } from "../../../../Components/Others/ToastServices";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";

export default function NewformCerti({ isEditing = true, allSubmitted }) {
  const { scheduleViewId } = useParams();
  const toastService = useToast();
    const location = useLocation();
  const [forms, setForms] = useState([]);


  const signOne = useRef(null);
  const signTwo = useRef(null);

  const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
    const form_data = location?.state?.form;
    const inspectiionId = form_data?.inspectiionId;

  const [formData, setFormData] = useState({
    signature1: null,
    signature2: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [oldSignatures, setOldSignatures] = useState({
    signature1: null,
    signature2: null,
  });
  const [signaturesToRemove, setSignaturesToRemove] = useState({
    signature1: null,
    signature2: null,
  });
  const [newFormDetails, setNewFormDetails] = useState(null);

  const form = location.state?.form;

 
  const getSignatures = () => {

     axiosInstance
      .get(`/schedules/get-signatures/${scheduleViewId}`)
      .then((res) => {
        const responseData = res.data?.data;
        setNewFormDetails(responseData);

        setOldSignatures({
          signature1: responseData?.signature1?.file || null,
          signature2: responseData?.signature2?.file || null,
        });
        setFormData((prev) => ({
          signature1: prev.signature1 instanceof File ? prev.signature1 : null,
          signature2: prev.signature2 instanceof File ? prev.signature2 : null,
        }));
      })
      .catch((err) => {
        console.log("Error fetching signatures", err);
        toastService.open({
          type: "error",
          message: "Error",
          description: "Failed to load signatures.",
        });
      });
  };

  
  const removeSignature = (signatureKey) => {
    setFormData((prev) => ({
      ...prev,
      [signatureKey]: null,
    }));

    
    setSignaturesToRemove((prev) => ({
      ...prev,
      [signatureKey]: oldSignatures[signatureKey],
    }));

   
    setOldSignatures((prev) => ({
      ...prev,
      [signatureKey]: null,
    }));

    
    if (signatureKey === "signature1" && signOne.current) {
      signOne.current.clear();
    } else if (signatureKey === "signature2" && signTwo.current) {
      signTwo.current.clear();
    }
  };

   const saveSignatures = () => {
    setIsSubmitting(true);

    const submitData = new FormData();

       if (formData.signature1 instanceof File) {
      submitData.append("signature1", formData.signature1);
    }
    if (formData.signature2 instanceof File) {
      submitData.append("signature2", formData.signature2);
    }

     const jsonData = {
      oldSign1: signaturesToRemove.signature1 ? "" : oldSignatures.signature1,
      oldSign2: signaturesToRemove.signature2 ? "" : oldSignatures.signature2,
    };

    submitData.append("json_data", JSON.stringify(jsonData));

    axiosInstance
      .put(`/schedules/edit-signatures/${scheduleViewId}`, submitData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        setIsSubmitting(false);
        toastService.open({
          type: "success",
          message: "Success",
          description: "Signatures saved successfully.",
        });

        setSignaturesToRemove({ signature1: null, signature2: null });
        getSignatures();
      })
      .catch((err) => {
        setIsSubmitting(false);
        console.log("Error saving signatures", err);
        toastService.open({
          type: "error",
          message: "Error",
          description: "Failed to save signatures.",
        });
      });
  };
  

  useEffect(() => {
    getSignatures();
  }, [scheduleViewId]);
  const formatDateTime = (dateTime) => {
    if (!dateTime) return 'N/A';

    const date = new Date(dateTime);

    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-');

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  const currentForm = forms.find(item => item.id === parseInt(scheduleViewId)) || form;


  return (
     <div className="w-full h-full py-2 px-2 sm:px-4">
                <div className="flex justify-between gap-2 sm:gap-0">
                    <Breadcrumb
                        items={[
                            {
                                name: "Schedule",
                                link:`/inspection/schedule/newform/${scheduleViewId}`
                            },
                            { name: "Form Certificate" },
                        ]}
                    />
                    <div className="flex gap-2 justify-start sm:justify-end">
                        <Link
                            to={`/inspection/schedule/newform/${scheduleViewId}`}
                            state={{
                                currentPage: pageIndex,
                                searchQuery: searchQuery != "" ? searchQuery : "",
                            }}
                        >
                            <BackButton link={true} />
                        </Link>
                    </div>
                </div>
                  {currentForm && (
              <div className="h-auto  rounded-lg p-2">
                <div className="md:flex gap-4 w-full">
  <div className="flex gap-3">
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Schedule :</div>
      <div className="text-[#606279] text-xs flex-1 mx-1">
        {formatDateTime(currentForm.dateTime)}
      </div>
    </div>
    
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Assigned To :</div>
      <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
        {currentForm.assignees && currentForm.assignees.length > 0 
          ? currentForm.assignees.map(a => a.assigneeName).join(", ") 
          : 'Unassigned'
        }
      </div>
    </div>
    
    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Updated by :</div>
      <div className="text-[#606279] text-xs flex-1 mx-1">
        {currentForm.updatedByName || 'None'}
      </div>
    </div>

    <div className="flex items-start">
      <div className=" flex-shrink-0 font-medium text-xs">Last Updated :</div>
      <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
        {currentForm.updatedOn ? formatDateTime(currentForm.updatedOn) : 'Never'}
      </div>
    </div>
  </div>
  
</div>

              </div>
        
            )}
    <div className="bg-white mx-auto mt-4 h-[calc(100vh-145px)] w-full rounded-md flex flex-col overflow-y-auto p-2 sm:p-4">
      <div className="mx-auto w-full h-[calc(100vh-170px)] overflow-y-auto rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5 print:shadow-none print:ring-0 print:rounded-none print:p-8">
     
        <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
          <div className="text-center">
            <p className="text-xl font-semibold tracking-wide text-gray-900 uppercase">
              INSPECTION CERTIFICATE
            </p>
            <p className="text-sm text-gray-600 mt-1 text-left">
              {newFormDetails?.certRefNumber || "N/A"}
            </p>
          </div>
        </div>

        <div className="my-4 border-t" />

        <div className="text-center">
          <h2 className="text-lg font-semibold tracking-wide text-gray-900 uppercase">
            {newFormDetails?.inspection?.description || "Inspection"}
          </h2>
          <div
            className={`mt-2 inline-flex items-center gap-2 text-[16px] font-semibold ${
              allSubmitted ? "text-green-600" : "text-orange-500"
            }`}
          >
            {allSubmitted ? "Complete" : "Draft"}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          <Card title="Client Information">
            <Field
              label="Company Name"
              value={newFormDetails?.client?.companyName || "N/A"}
            />
            <Field
              label="Reference"
              value={newFormDetails?.client?.refNumber || "N/A"}
            />
            <Field
              label="Email"
              value={newFormDetails?.client?.email || "N/A"}
            />
            <Field
              label="Phone"
              value={newFormDetails?.client?.phoneWithCC || "N/A"}
            />
            <Field
              label="Address"
              value={`${newFormDetails?.client?.address1 || ""}, ${
                newFormDetails?.client?.address2 || ""
              }`}
            />
            <Field
              label="Street"
              value={newFormDetails?.client?.streetName || "N/A"}
            />
            <Field
              label="City"
              value={newFormDetails?.client?.city || "N/A"}
            />
            <Field
              label="District"
              value={newFormDetails?.client?.district || "N/A"}
            />
            <Field
              label="State"
              value={newFormDetails?.client?.state || "N/A"}
            />
            <Field
              label="Postal Code"
              value={newFormDetails?.client?.postalCode || "N/A"}
            />
            <Field
              label="Country"
              value={newFormDetails?.client?.country || "N/A"}
            />
          </Card>

          <Card title="Inspection Details">
            <Field
              label="Reference No."
              value={newFormDetails?.inspection?.refNumber || "N/A"}
            />
            <Field
              label="Inspection Date"
              value={<NuDate value={newFormDetails?.inspection?.date} />}
            />
            <Field
              label="Location"
              value={newFormDetails?.inspection?.location || "N/A"}
            />
            <Field
              label="Priority"
              value={newFormDetails?.inspection?.priority || "N/A"}
            />
            <Field
              label="Status"
              value={newFormDetails?.inspection?.status || "N/A"}
            />
            <Field
              label="Approval Status"
              value={newFormDetails?.inspection?.approvalStatus || "N/A"}
            />
          </Card>
        </div>

         <Card title="Inspection Summary" className="">
           <p className="text-gray-700 leading-relaxed">This is to certify that the above referenced system has been inspected in accordance to NFPA standards and please note below the comments.</p>
         </Card>
          {newFormDetails?.forms.length > 0 && (

  <Card title="Form" className="">
            <ul className="space-y-4">
              {newFormDetails?.forms.map((def, i) => (
                <li
                  key={i}
                  className="rounded-xl border p-4 shadow-sm ring-1 ring-black/5"
                >
                  <div className="flex gap-3">
                    <div className="w-1.5 shrink-0 rounded-full bg-yellow-500" />
                    <div className="space-y-1">
                      <p className="font-semibold text-gray-900">
                        {def.formName}
                      </p>
                      <p className="text-gray-700">
                        <span className="font-semibold">
                          Recommended Action:
                        </span>{" "}
                        {def.comments}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          
        </Card>)}
        <div className="mt-6 w-full grid md:grid-cols-2 gap-6 py-2 px-2 mb-10">
          <SignatureBox
            label="inspector"
            refCanvas={signOne}
            formData={formData}
            setFormData={setFormData}
            isEditing={isEditing}
            onRemove={() => removeSignature("signature1")}
            toast={toastService}
            oldSignature={oldSignatures.signature1}
          />

          <SignatureBox
            label="customer"
            refCanvas={signTwo}
            formData={formData}
            setFormData={setFormData}
            isEditing={isEditing}
            onRemove={() => removeSignature("signature2")}
            toast={toastService}
            oldSignature={oldSignatures.signature2}
          />
        </div>

        <div className="flex justify-end">
          <button
            className={`${
              isSubmitting ? "bg-red-300 cursor-wait" : "bg-textColor-main"
            } px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center mr-3`}
            onClick={saveSignatures}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save Signatures"}
          </button>
        </div>
      </div>
    </div>
    </div>
  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-2xl border bg-white p-5 shadow-sm ring-1 ring-black/5 my-4">
      {title ? (
        <h3 className="mb-3 text-lg font-semibold text-gray-900">{title}</h3>
      ) : null}
      <div className="space-y-2">{children}</div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div className="flex w-full justify-between">
      <p className="font-semibold text-gray-700 w-1/2">{label}</p>
      <span className="text-gray-500 w-1/2">: {value}</span>
    </div>
  );
}


function SignatureBox({
  label,
  refCanvas,
  formData,
  setFormData,
  isEditing,
  onRemove,
  toast,
  oldSignature,
}) {
  const signatureKey = `signature${label === "inspector" ? "1" : "2"}`;


  const getSignatureImageUrl = () => {
    const signatureData = formData[signatureKey];
    if (signatureData instanceof File) {
      return URL.createObjectURL(signatureData);
    }
    if (oldSignature) {
      return oldSignature; 
    }
    return null;
  };

  const signatureImageUrl = getSignatureImageUrl();

  const dataURLtoBlob = (dataURL) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleSaveSignature = () => {
    if (!isEditing) return;

    if (signatureImageUrl) {
          onRemove();
    } else if (refCanvas.current) {
      if (refCanvas.current.isEmpty()) {
        toast.open({
          type: "error",
          message: "Error",
          description: "Please provide a signature first",
        });
        return;
      }
      const dataURL = refCanvas.current.toDataURL("image/png");
      const blob = dataURLtoBlob(dataURL);
      const file = new File([blob], `${signatureKey}.png`, {
        type: "image/png",
      });

         setFormData((prev) => ({
        ...prev,
        [signatureKey]: file,
      }));

         refCanvas.current.clear();
    }
  };

  const handleResetSignature = () => {
    if (refCanvas.current) {
      refCanvas.current.clear();
    }
  };

  return (
    <div className="relative border w-full h-64 p-2 rounded-md bg-white">
      {signatureImageUrl ? (
        <img
          src={signatureImageUrl}
          alt={`${label} Signature`}
          className="border border-gray-400 w-full h-52 rounded-md object-contain"
        />
      ) : (
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            className: "border border-gray-400 w-full h-52 rounded-md",
            disabled: !isEditing,
          }}
          ref={refCanvas}
        />
      )}

      <div className="flex justify-between items-center mt-1">
        <span className="text-xs font-semibold text-gray-500 capitalize">
          {label} :
        </span>
        <div className="flex gap-3">
            {!signatureImageUrl && (
            <button
              type="button"
              disabled={!isEditing}
              onClick={handleResetSignature}
              className="text-xs px-3 py-1 rounded-md font-medium bg-yellow-400 text-white"
            >
              Reset
            </button>
          )}

          <button
            type="button"
            disabled={!isEditing}
            onClick={handleSaveSignature}
            className={`text-xs px-3 py-1 rounded-md font-medium ${
              signatureImageUrl
                ? "bg-red-500 text-white"
                : "bg-gray-200 text-textColor-main"
            }`}
          >
            {signatureImageUrl ? "Remove" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}



